import * as React from "react";
import { IToggleBoxGroupProps } from "./ToggleBoxGroup.types";
import { ICategoryItem } from "../FilterList/FilterList.types";
import { ToggleBox } from "../ToggleBox/ToggleBox";

export class ToggleBoxGroup extends React.Component<IToggleBoxGroupProps> {
  static defaultProps = {
    onChangeCb: () => {},
    legendSrOnly: false,
  };
  constructor(props: IToggleBoxGroupProps) {
    super(props);
  }

  renderToggleBox = (item: ICategoryItem, i: number) => {
    return (
      <ToggleBox
        key={`operationsbox-${i}`}
        label={item.Name}
        value={item.Id.toString()}
        cssClass=""
        onChangeCb={this.props.onChangeCb}
        inputType="radio"
        inputName="filtergroup"
        hideToggleBox={item.Hidden}
      />
    );
  };
  renderToggleBoxNames = (item: string, i: number) => {
    return (
      <ToggleBox
        key={`operationsbox-${i}`}
        label={item}
        value={item}
        cssClass=""
        onChangeCb={this.props.onChangeCb}
        inputType="radio"
        inputName="filtergroup"
      />
    );
  };

  render() {
    const {
      categoryList,
      categoryNames,
      filterHeading,
      legendSrOnly,
      fieldsetCssclass,
    } = this.props;
    return (
      <fieldset
        className={`d-none d-md-block ${
          fieldsetCssclass ? fieldsetCssclass : ""
        }`}
      >
        <legend
          className={`filter-list__heading ${legendSrOnly ? "sr-only" : ""}`}
        >
          {filterHeading ? filterHeading : "Filtrera på"}
        </legend>
        <div className="d-flex flex-wrap">
          {categoryList
            ? categoryList.map(this.renderToggleBox)
            : categoryNames
            ? categoryNames.map(this.renderToggleBoxNames)
            : null}
        </div>
      </fieldset>
    );
  }
}
